import React, { useContext, useState } from "react";
import classes from "./EditTask.module.scss";
import Modal from "../Modal/Modal";
import { ModalContext } from "../../store/modal-context";
import { BoardContext } from "../../store/board-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";

const EditTask = () => {
  const { modalPayload, closeModal } = useContext(ModalContext);
  const { boards, editTask } = useContext(BoardContext);
  const { boardId, columnId, taskId } = modalPayload;

  const board = boards.find((b) => b.id === boardId);
  const column = board?.columns.find((col) => col.id === columnId);
  const task = column?.tasks.find((t) => t.id === taskId);

  const [title, setTitle] = useState(task?.title || "");
  const [description, setDescription] = useState(task?.description || "");
  const [subtasks, setSubtasks] = useState(task?.subTasks || []);
  const [status, setStatus] = useState(columnId);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!board || !column || !task) return null;

  const handleSubtaskChange = (index, value) => {
    setSubtasks((prev) =>
      prev.map((st, i) => (i === index ? { ...st, title: value } : st))
    );
  };

  const handleAddSubtask = (e) => {
    e.preventDefault();
    setSubtasks((prev) => [
      ...prev,
      { id: Date.now() + Math.random(), title: "", isCompleted: false },
    ]);
  };

  const handleRemoveSubtask = (index) => {
    setSubtasks((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const trimmedTitle = title.trim();
    if (!trimmedTitle) {
      alert("Please enter a task title.");
      return;
    }

    const validSubtasks = subtasks
      .filter((st) => st.title.trim())
      .map((st) => ({ ...st, title: st.title.trim() }));

    setIsSubmitting(true);
    await editTask(
      boardId,
      taskId,
      { title: trimmedTitle, description: description.trim(), subTasks: validSubtasks },
      status
    );
    setIsSubmitting(false);
    closeModal();
  };

  return (
    <Modal>
      <form className={`${classes.edit_task}`} onSubmit={handleSave}>
        <h3>Edit Task</h3>
        <section className={`${classes.inputSection}`}>
          <label htmlFor="edit-task-title">Title</label>
          <input
            id="edit-task-title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </section>
        <section className={`${classes.inputSection}`}>
          <label htmlFor="description">Description</label>
          <textarea
            name="description"
            id="description"
            className={classes.desc_textarea}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
        </section>
        <section className={`${classes.subtasks_section}`}>
          <p>Subtasks</p>
          <section className={classes.board_column_names}>
            {subtasks.map((subtask, index) => (
              <div key={subtask.id}>
                <input
                  type="text"
                  value={subtask.title}
                  onChange={(e) => handleSubtaskChange(index, e.target.value)}
                />
                <button
                  type="button"
                  aria-label={`Remove subtask ${subtask.title || index + 1}`}
                  className={classes.xMarkButton}
                  onClick={() => handleRemoveSubtask(index)}
                >
                  <FontAwesomeIcon icon={faX} className={classes.xMark} aria-hidden="true" />
                </button>
              </div>
            ))}
          </section>
          <button
            className={`${classes.add_new_column}`}
            onClick={handleAddSubtask}
            disabled={isSubmitting}
          >
            +add new subtask
          </button>
          <section className={classes.inputSection}>
            <label htmlFor="status">Status</label>
            <select
              name="status"
              id="status"
              className={`${classes.status}`}
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              {board.columns.map((col) => (
                <option key={col.id} value={col.id}>
                  {col.name}
                </option>
              ))}
            </select>
          </section>
          <button className={classes.save_changes} type="submit" disabled={isSubmitting}>
            {isSubmitting ? "saving…" : "save changes"}
          </button>
        </section>
      </form>
    </Modal>
  );
};

export default EditTask;
